import type { ReactNode } from 'react'
import { Loader2, AlertTriangle, Inbox } from 'lucide-react'

export function Spinner({ className = '', size = 16 }: { className?: string; size?: number }) {
  return <Loader2 size={size} className={`animate-spin ${className}`} />
}

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center gap-2 py-10 px-4">
      <div className="text-text-faint mb-1">{icon ?? <Inbox size={28} />}</div>
      <div className="text-sm font-medium text-text-muted">{title}</div>
      {description && <div className="text-xs text-text-faint max-w-[220px]">{description}</div>}
      {action}
    </div>
  )
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center text-center gap-2 py-8 px-4">
      <AlertTriangle size={24} className="text-accent-red" />
      <div className="text-xs text-accent-red max-w-[240px] break-words">{message}</div>
      {onRetry && (
        <button onClick={onRetry} className="text-xs text-accent-blue hover:underline mt-1">
          再試行
        </button>
      )}
    </div>
  )
}

export function LoadingState({ label = '読み込み中…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-10 text-text-faint">
      <Spinner size={20} />
      <div className="text-xs">{label}</div>
    </div>
  )
}
